import { useLayoutEffect, type RefObject } from "react";
import { useLocation } from "react-router-dom";

interface ScrollControllerProps {
  containerRef: RefObject<HTMLElement | null>;
}

const ScrollController = ({ containerRef }: ScrollControllerProps) => {
  const { pathname } = useLocation();

  useLayoutEffect(() => {
    containerRef.current?.scrollTo({ top: 0, left: 0, behavior: "auto" });
  }, [containerRef, pathname]);

  return null;
};

export default ScrollController;
